import { useMemo } from "react";
import { useParams } from "react-router-dom";
import { getAppInfo } from "../api/query";
import type { GetAppInfoQuery, GetAppInfoQueryVariables } from "../api/query/getAppInfo.gql-generated";
import { useQuery } from "@apollo/client";
import { AppInfoModel } from "../model/AppInfoModel";
import { type RouteParams, AbsoluteRoute } from "../../../../core/routes";

export function useGetAppInfo() {
    const { orgId, appId } = useParams<RouteParams[AbsoluteRoute.ORG_APP]>();
    const { loading, data } = useQuery<GetAppInfoQuery, GetAppInfoQueryVariables>(getAppInfo, {
        variables: {
            appId: appId ?? "",
            orgId: orgId ?? "",
        },
    });

    const appInfo = useMemo(
        () =>
            (data?.getAppInfo?.application && AppInfoModel.createAppInfoItem(data?.getAppInfo.application)) ||
            ({} as AppInfoModel),
        [data],
    );

    return {
        appInfo,
        loading,
        organizationName: data?.selectedOrganization?.name,
        demoGroupId: data?.getGroupListV2?.groupsWithConnections?.[0]?.group?.id ?? "",
    };
}
